import * as CheckPermission from './checkPermission.js';

export default function (context) {
  CheckPermission.checkPermission(context, 'employee');
}
